@for (error of (ngControl?.errors || control?.errors || {}) | keyvalue; track error; let last = $last) {
  @if (last) {
    <div class="helper error">{{ (errors[error.key] || error.key) | replace : error.value }}</div>
  }
}
